// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3huKq","content":"ManualTimeModal_content__3L9IN"};